import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const loyaltyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.LoyaltyProgramInternalView, Permission.LoyaltyProgramInternalModify],
}
